module.exports = __webpack_public_path__ + "img/bi.1adef5a9.jpeg";